import React, { FormEvent, ReactElement } from 'react';
import {
  Button, Col, Heading, LoaderButton, Row, Text,
} from 'idsk-react-components';
import { BackButton } from 'slovlex-idsk-react-components';
import { v4 as uuidv4 } from 'uuid';
import Definicia from '../../../../../model/Definicia';
import LegalnaDefiniciaItem from './LegalnaDefiniciaItem';
import addIcon from '../../../../../../assets/images/icon-plus-dark.svg';

interface Props {
  legalneDefinicie: Array<Definicia>;
  setLegalneDefinicie: (legalneDefinicie: Array<Definicia>) => void;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
  getFieldErrorMessage: (fieldName: string) => string | undefined;
  clearFieldErrorMessage?: (fieldName: string) => void;
  clearAllFieldErrorMessages?: () => void;
  loading: boolean;
}

const LegalneDefinicieUpdateForm = ({
  legalneDefinicie,
  setLegalneDefinicie,
  onSubmit,
  getFieldErrorMessage,
  clearFieldErrorMessage,
  clearAllFieldErrorMessages,
  loading,
}: Props): ReactElement => {
  const addDefinicia = async (): Promise<void> => {
    setLegalneDefinicie([...legalneDefinicie, {
      key: uuidv4(), definicia: '', zdroj: '', uuid: '', popisLegislativnehoZdroja: '',
    }]);
  };

  return (
    <>
      <Heading size="l" className="legalna-definicia-heading">Legálne definície</Heading>
      <form onSubmit={onSubmit} className="admin-termin-create-form">
        {legalneDefinicie?.map((definicia, index) => (
          <LegalnaDefiniciaItem
            key={definicia.key || definicia.uuid}
            itemList={legalneDefinicie}
            setItemList={setLegalneDefinicie}
            itemId={index}
            getFieldErrorMessage={getFieldErrorMessage}
            clearFieldErrorMessage={clearFieldErrorMessage}
            clearAllFieldErrorMessages={clearAllFieldErrorMessages}
          >
            {index === legalneDefinicie.length - 1 && (
              <Button
                size="large"
                onClick={addDefinicia}
                iconBefore={addIcon}
                buttonStyle="third"
              >Pridať legálnu definíciu
              </Button>
            )}
          </LegalnaDefiniciaItem>
        ))}
        {legalneDefinicie.length === 0 && (
          <>
            <Text className="legalna-definicia-item">
              Prázdny zoznam legálnych definícií.
            </Text>
            <Button
              size="large"
              onClick={addDefinicia}
              iconBefore={addIcon}
              buttonStyle="third"
            >Pridať legálnu definíciu
            </Button>
          </>
        )}
        <Row className="admin-termin-create__actions">
          <Col width="one-half">
            <LoaderButton
              className="admin-termin-create__create-button"
              loading={loading}
              type="submit"
              size="large"
            >
              Uložiť zmeny
            </LoaderButton>
            <BackButton disabled={loading} />
          </Col>
        </Row>
      </form>
    </>
  );
};

export default LegalneDefinicieUpdateForm;
